import { CurrencyFormat, DateTimeFormat, DateInputMaskFormat } from '@paypalcorp/worldready';
import { getWorldReady } from './worldReadyUtils';

/**
 * Creates WorldReady formatter functions for IntlProvider
 * This centralizes the formatter creation logic used across multiple entry points
 */

/**
 * Creates a currencyFormatter function using WorldReady
 * @returns {Function|null} Currency formatter function or null if WorldReady not available
 */
const createCurrencyFormatter = () => {
  const worldReady = getWorldReady();
  if (worldReady) {
    return (options = {}) => new CurrencyFormat(worldReady, options);
  }
  return null;
};

/**
 * Creates a dateTimeFormatter function using WorldReady
 * @returns {Function|null} DateTime formatter function or null if WorldReady not available
 */
const createDateTimeFormatter = () => {
  const worldReady = getWorldReady();
  if (worldReady) {
    return (options = {}) => new DateTimeFormat(worldReady, options);
  }
  return null;
};

/**
 * Creates a dateInputMaskFormatter function using WorldReady
 * @returns {Function|null} DateInputMask formatter function or null if WorldReady not available
 */
const createDateInputMaskFormatter = () => {
  const worldReady = getWorldReady();
  if (worldReady) {
    return (options = {}) => new DateInputMaskFormat(worldReady, options);
  }
  return null;
};

/**
 * Creates complete IntlProvider props with all formatters
 * @param {string} locale - The locale string (e.g., 'en-US')
 * @returns {object} IntlProvider props object with locale and formatters
 */
export const createIntlProviderProps = (locale) => {
  return {
    locale,
    currencyFormatter: createCurrencyFormatter(),
    dateTimeFormatter: createDateTimeFormatter(),
    dateInputMaskFormat: createDateInputMaskFormatter(),
  };
};

